import { configureStore } from "@reduxjs/toolkit";
import alertMessage from "../slice/alertMessage";
import { rtkQueryErrorLogger } from "../slice/errorLogger";
import cartList from "../slice/cartList";

//

const store = configureStore({
  reducer: {
    alertMessage: alertMessage,
    cartList: cartList,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export default store;
